import { BfNoticeStore } from '@tw/tw-runtime';

export class NoticeStore extends BfNoticeStore {
  protected isAutoSelectTopic() {
    return false;
  }
}
